import {PropsWithChildren, ReactNode, useState} from 'react';
import styled from "@emotion/styled/macro";
import NavMenu from "../navMenu/NavMenu";
import {useNavigate} from "react-router-dom";

const TopNavDiv = styled.div`
  padding-left: 36.5px;
  padding-right:36.5px;
  width:100%;
  box-sizing: border-box;
  height:50px;
    display:flex;
  align-items: center;
  justify-content:space-around;
  .logo, .profile { position:absolute; left:32px; flex: 0 0 200px };
  .navRight { text-align:right;}
  .profile > button {
    background: none;
    border: none;
    padding: 0;
  }
`

const TopNavTitleDiv = styled.div`
    width:100%;
`

/**
 * TopNavBanner is a div used in a header that contains the logo, title and the menu button.
 * Not used directly, only through the main layout components.
 * @param props
 * @constructor
 */
const TopNavBanner: React.FC<PropsWithChildren<{logoUrl: string, right?: ReactNode }>> = (props) => {
    const [navMenuActive, setNavMenuActive] = useState(false);
    const { logoUrl } = props;
    const navigate = useNavigate();

    return (
        <TopNavDiv>
            <div className={"logo"} onClick={()=>{navigate('/')}}>
                <img src={logoUrl}/>
            </div>
            <TopNavTitleDiv>
                {props.children}
            </TopNavTitleDiv>
            <div className={"navRight"}>
                { props.right }
            </div>
            { /* div className={"profile"}>
                <button onClick={() => setNavMenuActive(true)}>
                    <img className="profile" height={32} width={32} src={"/images/profile.svg"}/>
                </button>
            </div> */ }
            { /*  <NavMenu
              navMenuActive={navMenuActive}
              setNavMenuActive={setNavMenuActive}
            /> */ }
        </TopNavDiv>
    );
}

export default TopNavBanner;